import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
import Bredcrumb from "../components/Bredcrumb";

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;

const LegalDisclaimer = () => {
  return (
    <>
      <CustomHelmet
        title="Disclaimer - Arcaptor Technologies"
        description="Read the Disclaimer for Arcaptor Technologies' services. Understand the limitations, liabilities, and clarifications regarding the use of our platform and offerings."
      />
      <MainLayout>
        <Bredcrumb
          paddingY="30px"
          heading="Legal Disclaimer"
          image="./images/Legal.png"
          imgStyleHeight="300px"

        />
        <Container>
          <TextContent>
            <h2 className="main_heading">Disclaimer</h2>
            <p>
              ARCAPTOR TECHNOLOGIES retains full copyright over all text,
              content, graphics, and trademarks displayed on this website. These
              materials are the sole property of ARCAPTOR TECHNOLOGIES and are
              protected under applicable copyright laws.
            </p>
            <br />
            <p>
              The information provided on this website is included in good faith
              and is intended for general informational purposes only. It should
              not be relied upon for any specific purpose without further
              verification. Users are prohibited from distributing text or
              graphics to third parties without the express written consent of
              ARCAPTOR TECHNOLOGIES. Additionally, users must not copy,
              distribute, modify, or reuse any information or materials from
              this website on any other server or platform without prior
              authorization.
            </p>

            <br />
            <p>
              While ARCAPTOR TECHNOLOGIES endeavors to ensure that the
              information provided on this website, including details about
              products, services, and offerings, is accurate at the time of
              publication, it does not guarantee the completeness or accuracy of
              such information. ARCAPTOR TECHNOLOGIES makes no warranties,
              express or implied, regarding the reliability, accuracy, or
              completeness of the information.
            </p>
            <br />
            <p>
              This website may contain links to third-party websites over which
              ARCAPTOR TECHNOLOGIES has no control. ARCAPTOR TECHNOLOGIES does
              not endorse, guarantee, or make representations regarding the
              content or accuracy of information on such external sites.
            </p>
            <br />
            <h4>Limitation of Liability</h4>
            <br />
            <p>
              ARCAPTOR TECHNOLOGIES disclaims all warranties and conditions,
              whether express or implied, including but not limited to implied
              warranties of merchantability, fitness for a particular purpose,
              title, and non-infringement. Under no circumstances shall ARCAPTOR
              TECHNOLOGIES, its affiliates, employees, or agents be liable for
              any decisions made or actions taken based on the information
              provided on this site. This includes any consequential, special,
              or similar damages arising from the use of or reliance on the
              information provided.
            </p>
            <br />
            <h4>Governing Law and Jurisdiction</h4>

            <br />
            <p>
              This Disclaimer is governed by and shall be interpreted in
              accordance with the laws of India. In the event of any disputes
              arising in connection with this Disclaimer or the use of this
              website, such disputes shall be subject to the exclusive
              jurisdiction of the courts located in Delhi, India.
            </p>
            <br />
            <h4>Forward-Looking Statements</h4>
            <br />
            <p>
              Statements on this website containing words or phrases such as
              “will,” “aim,” “believe,” “expect,” “may,” “anticipate,” “intend,”
              “plan,” “seek,” “future,” “goal,” “likely,” “should,” and similar
              expressions may constitute forward-looking statements. These
              statements involve risks, uncertainties, and factors that could
              cause actual outcomes to differ materially from the expectations
              outlined in such statements. These risks include, but are not
              limited to, challenges in implementing strategies, obtaining
              regulatory approvals, technological advancements, market risks,
              and financial projections. ARCAPTOR TECHNOLOGIES does not
              undertake any obligation to update forward-looking statements to
              reflect future events or changes in circumstances.
            </p>
            <br />
            <h4>Copyright Notice</h4>
            <br />
            <p>Copyright © ARCAPTOR TECHNOLOGIES. All rights reserved.</p>
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default LegalDisclaimer;
